import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css'
import { formatTime } from './utils/datetime'

Vue.use(Vant)
Vue.config.productionTip = false

Vue.prototype.$formatTime = formatTime
Vue.filter('datetime', formatTime)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
